import { Carbon } from 'Carbon.Frontend/Resources/Private/Assets/Carbon';
import domReady from 'Carbon.Frontend/Resources/Private/Assets/Scripts/domReady';
import nodeArray from 'Carbon.Frontend/Resources/Private/Assets/Scripts/nodeArray';
import Gator from 'gator';
import 'Carbon.Frontend/Resources/Private/Assets/Scripts/tabbingClass';
import 'Carbon.Frontend/Resources/Private/Assets/Scripts/inputTypeClass';

window.Carbon = Carbon;

Carbon('domReady', domReady);
Carbon('nodeArray', nodeArray);
Carbon('Gator', Gator);
